import { ApiSmpStream } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

import { useContextApp } from "@/screens/app/context/app";

const KEY = "smp.stream.stream";

export const useSmpStreamStreamList = (options?: {
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpStream.Stream.list>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    state: { organizationId },
  } = useContextApp();

  const {
    data: streamStreamList,
    isLoading: isStreamStreamListLoading,
    error: streamStreamListError,
  } = useQuery(
    [KEY, { organizationId }],
    () => ApiSmpStream.Stream.list(),
    options?.useQueryOptions,
  );

  return {
    isStreamStreamListLoading,
    streamStreamList,
    streamStreamListError,
  };
};

useSmpStreamStreamList.KEY = KEY;
